import { useOrderState } from '@order/hooks/useOrderState'
import { useLocalSearchParams } from 'expo-router'
import { useIsFocused } from '@ui/hooks/useIsFocused'
import { useEffect } from 'react'

export const useSyncActiveItem = () => {
  const { orderItemId } = useLocalSearchParams<{
    orderItemId: string
  }>()
  const switchActiveItem = useOrderState((s) => s.switchActiveItem)
  const activeItemId = useOrderState((s) => s.order.activeItemId)
  const focused = useIsFocused()
  useEffect(() => {
    if (!focused || !orderItemId) {
      return
    }
    if (orderItemId !== activeItemId) {
      switchActiveItem(orderItemId)
    }
  }, [orderItemId, activeItemId, focused, switchActiveItem])

  return {
    orderItemId,
    activeItemId,
  }
}
